import { Injectable, Inject } from '@angular/core';
import {BIM_CONFIG, BimConfig} from './config';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor( @Inject(BIM_CONFIG) private config) {
    console.log('ctor ConfigService');
  }

  getConfig(): BimConfig {
    return this.config;
  }
}
